export const StageDescriptionRects = [
  { left: 40, top: 750 },
  { left: 800, top: 96 },
  { left: 400, top: 126 },
  { left: 120, top: 730 },
  { left: 40, top: 750 },
  { left: 340, top: 730 },
];
